// react import
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import deepCopy from "../hooks/deepCopy";
import { commonAction } from "../../slices/GameSlice";

const FakeCardSubmit = () => {
  const dispatch = useDispatch();
  const {
    fakeCard: { fakeCardUsers, cardArr, turnStep, turnUser },
    fakeCardSubmitList,
    fakeCardSubmitLabel,
  } = useSelector(state => state.GameSlice);
  const { userId } = useSelector(state => state.LoginInfoSlice);

  const cardsKinds = [
    "map",
    "ceramic",
    "compass",
    "coin",
    "machete",
    "canteen",
  ];

  const kindColors = {
    map: "red",
    ceramic: "blue",
    compass: "yellow",
    coin: "green",
    machete: "orange",
    canteen: "purple",
  };

  const checkSubmitTurn = useMemo(
    () => turnUser?.userId === userId && (turnStep === 1 || turnStep === 2),
    [turnStep, userId, turnUser]
  );

  const selfUser = useMemo(
    () => fakeCardUsers.find(i => i?.userId === userId),
    [fakeCardUsers, userId]
  );

  const haveCards = useMemo(() => {
    const kindSorts = {
      map: 1,
      ceramic: 2,
      compass: 3,
      coin: 4,
      machete: 5,
      canteen: 6,
    };

    return deepCopy(selfUser?.cards)?.sort?.(
      (a, b) => kindSorts[b?.label] - kindSorts[a?.label]
    );
  }, [selfUser]);

  return (
    <Wrap>
      <CardContainer>
        {haveCards?.map((item, index) => {
          const cardColor = kindColors[item?.label];
          const checkIncludes = fakeCardSubmitList.some(
            i => i?.label === item?.label && i?.order === item?.order
          );

          const handler = () => {
            if (checkSubmitTurn) {
              const value = !checkIncludes
                ? [...fakeCardSubmitList, item]
                : fakeCardSubmitList.filter(
                    i => !(i?.label === item?.label && i?.order === item?.order)
                  );

              dispatch(
                commonAction({
                  target: "fakeCardSubmitList",
                  value,
                })
              );
            }
          };
          return (
            <CardItem
              $include={checkIncludes}
              style={{ backgroundColor: cardColor }}
              onClick={handler}
              key={`${index}submitCardsKey`}></CardItem>
          );
        })}
      </CardContainer>
      <LabelContainer>
        {cardsKinds.map(item => {
          const cardColor = kindColors[item];

          const handler = () => {
            if (checkSubmitTurn) {
              dispatch(
                commonAction({
                  target: "fakeCardSubmitLabel",
                  value: fakeCardSubmitLabel === item ? "" : item,
                })
              );
            }
          };
          return (
            <KindItem
              style={{ backgroundColor: cardColor }}
              $select={fakeCardSubmitLabel === item}
              key={`${item}submitKindKey`}
              onClick={handler}
            />
          );
        })}
      </LabelContainer>
    </Wrap>
  );
};

export default FakeCardSubmit;

const Wrap = styled.div`
  width: 100%;
  height: 130px;
  display: flex;
  padding: 8px;
`;

const CardContainer = styled.div`
  width: 80%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  padding: 8px 3px;
  border: 1px solid black;
`;

const LabelContainer = styled.div`
  width: 20%;
  height: 100%;
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  border: 1px solid black;
  align-items: center;
  padding: 0 10px;
  justify-content: space-between;
`;

const CardItem = styled.div`
  width: 20px;
  height: 20px;
  color: #fff;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  ${({ $include }) => $include && "border: 2px solid black"};
`;

const KindItem = styled.div`
  width: 20px;
  height: 20px;
  opacity: ${({ $select }) => ($select ? 1 : 0.5)};
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
`;
